import type { HTTPStatus } from "../types";

/**
 * This error represents API request, which returned http status code different from 2xx (or unhandled 3xx).
 * See https://visionmedia.github.io/superagent/#error-handling for details on statuses.
 */
export class HTTPError extends Error {
    public readonly status: HTTPStatus;

    constructor(status: HTTPStatus, message?: string) {
        super(message);
        this.status = status;
    }
}
